export default [
  {
    path: '/h5/page1',
    name: 'h5-page1',
    component: () => import('@simple/views/h5/page1/page1.vue'),
  },
  {
    path: '/h5/page2',
    name: 'h5-page2',
    component: () => import('@simple/views/h5/page2/page2.vue'),
  },
  {
    path: '/h5/page3',
    name: 'h5-page3',
    component: () => import('@simple/views/h5/page3/page3.vue'),
  },
  {
    path: '/h5/page4',
    name: 'h5-page4',
    component: () => import('@simple/views/h5/page4/page4.vue'),
  },
];
